import React from 'react';
import { Icons, IconButton } from "@curves/ui-base";
import useDocumentApi from '@apis/useDocumentApi';
import useInBodyApi from '@apis/useInBodyApi';

const InbodySportAdviseDialog = (props) => {
    const { sourceData } = props;
    const { getSportAdvisePDFApi } = useDocumentApi();
    const { checkSportAdviseSaveApi } = useInBodyApi();

    const handleSportAdvise = () => {
        const { measureID } = sourceData;
        doSportAdviseApi(measureID);
    };

    const doSportAdviseApi = async (measureID) => {
        const healthDeclarationContractID = await checkSportAdviseSaveApi(measureID);
        if (healthDeclarationContractID > 0) {
            await getSportAdvisePDFApi(measureID, { healthDeclarationContractID });
        }
    };

    return (
        <IconButton onClick={handleSportAdvise}>
            <Icons.Download />
        </IconButton>
    );
};

export default InbodySportAdviseDialog;
